module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-secondary-bg-left.287cbd94.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-secondary-bg-left.png
// module id = 3604
// module chunks = 11